import React from "react";
import PropTypes from "prop-types";
import {
  CoverText,
  isConnectionPasswordVisible,
  PageHeightAuto,
  STATUS_LABELS,
} from "../../../../components/Utils";
import { InputText, Label } from "../../../../components/Inputs";
import {
  PermissionResource,
  PermissionSection,
  Resources,
} from "../../../Permissions";
import { ADConnectionPanel } from "../wizard/ADConnectionListForm";
import { ANPConnectionPanel } from "../wizard/ANPConnectionListForm";
import { DelphiConnectionPanel } from "../wizard/DelphiConnectionListForm";
import { JarvisConnectionPanel } from "../wizard/JarvisConnectionListForm";

const ITConnectionPanel = ({ className, model, vfEmail }) => {
  const {
    ptConnection,
    ptUsername,
    ptPassword,
    ptStatus,
    ptStatus_id,
    ptModified_date,
    anpConnection,
    delphiConnections,
    jarvisConnection,
    ...adModel
  } = model;

  const showADPassword =
    adModel.adPassword &&
    adModel.adPassword !== "" &&
    isConnectionPasswordVisible(adModel.adModified_date);
  const showPTPassword =
    ptPassword &&
    ptPassword !== "" &&
    isConnectionPasswordVisible(ptModified_date);

  const ptConnectionExists =
    ptConnection && ptConnection.toLowerCase() === "ja";
  const ptMarkup = (
    <PermissionResource resource={Resources.Profile.PTConnections}>
      <PermissionSection
        height="auto"
        id="iprov-zugang"
        className="w3-border-top neg-margin-big-lr pad-big-lr pad-big-btm"
        isUnterWizardTitle
        idOffset={-90}
      >
        <h4 className="no-margin pad-big-top pad-btm">{"Prov.-tool-Zugang"}</h4>
        {!ptConnectionExists ? (
          <PageHeightAuto style={{ minHeight: "60px" }}>
            <CoverText>Kein iProv Zugang</CoverText>
          </PageHeightAuto>
        ) : (
          <div className="w3-row">
            <div className="w3-col s2 pad-lr pad-sm-tb">
              <Label>{`Prov.-tool-Zugang`}</Label>
              <InputText className="w3-block" value={ptConnection} readonly />
            </div>
            <div className="w3-col s8 pad-lr">
              <div className="w3-row neg-margin-lr">
                <div className="w3-col s3 pad-lr pad-sm-tb">
                  <Label>{`Kennung`}</Label>
                  <InputText className="w3-block" value={ptUsername} readonly />
                </div>
                {showPTPassword && (
                  <div className="w3-col s3 pad-lr pad-sm-tb">
                    <Label>{`Passwort`}</Label>
                    <InputText
                      className="w3-block"
                      value={ptPassword}
                      readonly
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="w3-col s2 pad-lr pad-sm-tb">
              <Label>{`Status`}</Label>
              <InputText
                className="w3-block"
                value={ptStatus || STATUS_LABELS[ptStatus_id]}
                readonly
              />
            </div>
          </div>
        )}
      </PermissionSection>
    </PermissionResource>
  );

  return (
    <div className={className}>
      <ADConnectionPanel
        model={{
          ...adModel,
          vf_email: vfEmail,
        }}
        viewVFEmail
        showPassword={showADPassword}
      />
      <ANPConnectionPanel anpConnection={anpConnection} />
      {ptMarkup}
      <DelphiConnectionPanel delphiConnections={delphiConnections} />
      <JarvisConnectionPanel jarvisConnection={jarvisConnection} />
    </div>
  );
};

ITConnectionPanel.propTypes = {
  className: PropTypes.string,
  model: PropTypes.shape({}),
  vfEmail: PropTypes.string,
  rows: PropTypes.number,
  children: PropTypes.node,
};

ITConnectionPanel.defaultProps = {
  className: "",
  model: {
    ptConnection: "",
    ptUsername: "",
    adConnection: "",
    adUsername: "",
    delphiConnections: [],
    jarvisConnection: [],
  },
  vfEmail: "",
  rows: 10,
};

export default ITConnectionPanel;
